/* assets/mp-price.js — Preisdarstellung ",00" -> ",-" (SEO-Sprint b, 2026-07-20)
 *
 * Server-seitig gerenderte Preise bekommen das ",-" bereits per Liquid
 * (`| money | replace: ',00', ',-'` in den Preis-Snippets/Sections).
 * Diese Datei deckt alles ab, was CLIENT-seitig formatiert wird:
 *
 *  - Varianten-Wechsel auf der Produktseite, Sticky-ATC, Quick-View/Quick-Shop,
 *    Cart-Drawer-Updates, FBT/Grouped-Totals, Preis-Slider-Labels (facets),
 *    Multi-Currency (t4s-currencies): alle laufen zentral ueber
 *    T4SThemeSP.Currency.formatMoney(cents, format) mit
 *    window.T4Sconfigs.moneyFormat (Shop-Setting "<span class=money>€{{amount_with_comma_separator}} </span>")
 *    -> Hook 1 wrappt formatMoney, sobald theme.min.js (lazy geladen) es
 *       definiert hat. Damit gelangt ",00" gar nicht erst ins DOM.
 *
 *  - Hook 2 (Sicherheitsnetz): MutationObserver korrigiert jede
 *    span.money, die trotzdem noch ",00" zeigt (z. B. App-Widgets oder
 *    per innerHTML eingesetzte, server-gerenderte Fragmente aus einem
 *    Cache-Stand vor dem Liquid-Fix).
 *
 * Regel: nur glatte Betraege — ",00" am Dezimalende (kein Digit danach)
 * wird zu ",-". Krumme Preise (z. B. 1.234,50) bleiben unveraendert.
 */
(function () {
  'use strict';
  var RE = /(\d),00(?!\d)/g;
  // €-Abstand (Felix 20.07.): schmales geschuetztes Leerzeichen U+202F zwischen
  // €-Zeichen und Betrag — Liquid-Seite nutzt dafuer &#8239; (identisches Zeichen).
  // (?=\S) verhindert Doppel-Anwendung: U+202F zaehlt in JS-Regex als \s.
  var RE_EUR = /€(?=\S)/g;
  function fixStr(s) { return s.replace(RE, '$1,-').replace(RE_EUR, '\u20ac\u202f'); }

  /* ---- Hook 1: zentrale JS-Formatierung wrappen ---- */
  var tries = 0;
  var timer = setInterval(function () {
    var T = window.T4SThemeSP;
    if (T && T.Currency && typeof T.Currency.formatMoney === 'function') {
      clearInterval(timer);
      if (T.Currency.formatMoney.__mpPriceWrapped) return;
      var orig = T.Currency.formatMoney;
      T.Currency.formatMoney = function () {
        return fixStr(String(orig.apply(this, arguments)));
      };
      T.Currency.formatMoney.__mpPriceWrapped = true;
    } else if (++tries > 200) { // ~20s, dann aufgeben (Observer bleibt aktiv)
      clearInterval(timer);
    }
  }, 100);

  /* ---- Hook 2: DOM-Sicherheitsnetz ---- */
  var scheduled = false;
  function scan() {
    scheduled = false;
    var nodes = document.querySelectorAll('span.money');
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      // nur reine Textspans anfassen (money-Format enthaelt kein Nested-HTML)
      if (el.firstElementChild) continue;
      var t = el.textContent;
      RE.lastIndex = 0; RE_EUR.lastIndex = 0;
      if (RE.test(t) || RE_EUR.test(t)) el.textContent = fixStr(t);
    }
  }
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    (window.requestAnimationFrame || window.setTimeout)(scan);
  }
  function arm() {
    schedule();
    var mo = new MutationObserver(schedule);
    mo.observe(document.body, { childList: true, subtree: true, characterData: true });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arm);
  } else {
    arm();
  }
})();

/* ---- WKC-Ergänzung 2026-07-24 ----------------------------------------
 * WKC rendert Preise NICHT in <span class="money">, sondern als Klartext in
 * .t4s-product-price / .t4s-cart__totalPrice u. ä. Das Sicherheitsnetz oben
 * greift dort also nicht. Diese Ergänzung läuft über einen TreeWalker NUR
 * innerhalb bekannter Preis-Container und ersetzt einzelne TEXTKNOTEN —
 * damit bleiben verschachtelte Streichpreise (<del>/<ins>) intakt.
 */
(function () {
  'use strict';
  var RE = /(\d),00(?!\d)/g;
  var RE_EUR = /€(?=\S)/g;
  var SEL = '.t4s-product-price,.t4s-cart__totalPrice,.t4s-product__price,' +
            '.mp-variant-b__price-block,.t4s-price,[data-product-price]';
  function fix(s) { return s.replace(RE, '$1,-').replace(RE_EUR, '€ '); }
  var queued = false;
  function scan() {
    queued = false;
    var hosts = document.querySelectorAll(SEL);
    for (var i = 0; i < hosts.length; i++) {
      var w = document.createTreeWalker(hosts[i], NodeFilter.SHOW_TEXT, null);
      var n;
      while ((n = w.nextNode())) {
        var t = n.nodeValue;
        if (!t) continue;
        RE.lastIndex = 0; RE_EUR.lastIndex = 0;
        if (RE.test(t) || RE_EUR.test(t)) n.nodeValue = fix(t);
      }
    }
  }
  function q() { if (!queued) { queued = true; setTimeout(scan, 60); } }
  function arm() {
    q();
    new MutationObserver(q).observe(document.body,
      { childList: true, subtree: true, characterData: true });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arm);
  } else { arm(); }
})();
